import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    check:{},
    error:null,
    procc:false
  },
  mutations: {
    SET_CHECK(state,payload){
      state.check = payload
    },
    SET_ERROR(state,payload){
      state.error = payload
    },
    SET_PROCC(state,payload){
      state.procc = payload
    }
  },
  actions: {
    PAY_CHECK({commit},payload){
      commit('SET_ERROR',null)
      commit('SET_PROCC',true)
      return Vue.$db.collection("orders")
      .where("label", "==", payload)
      .limit(1)
      .get()
      .then(querySnapshot =>{
        querySnapshot.forEach(s => {
            const data = s.data()
            let check =  data
            check.docid = s.id
            commit('SET_CHECK', check)
            commit('SET_PROCC', false)
        })
      })
      .catch(error=>{
        commit('SET_ERROR', error)
        commit('SET_PROCC', false)
      })
    }
  },
  getters: {
    getCheck: (state) => state.check,
    getProcc: (state) => state.procc,
    getError: (state) => state.error
  },
  modules: {
  }
})
